<template>
	<div class="positionView">
		<div class='svg' v-show="svgShow" :style="svgShow?'':'margin-top: 3.75rem;'">
			<SvgIcon :svg-name="svgName" size="60"></SvgIcon>
		</div>	
		<div class="img" @click="tocpz(cactive)"><img :src="imgs"></div>
		<div class="product-title">{{shopsTitle}}</div>
		<div class="product-write">{{leftList}}</div>
		<div style="display: flex; width: 85%;margin: 0 auto;text-align: left;">
			<div class="know" @click="tocpz(cactive)">查看更多></div>
			<div class="buy" @click="go_path(url)">立即购买></div>
		</div>
	</div>
</template>

<script>
	
	import SvgIcon from './SvgIcon.vue'
	
	export default{
		name:"positionView",
		components:{
			SvgIcon
		},
		props:{
			imgs:{
				type:String,
			},
			shopsTitle:{
				type:String,
			},
			leftList:{
				type:String,
			},
			svgName:{
				type:String,
			},
			cactive:{
				type:String,
			},
			url:{
				type:String,
			}
		},
		computed:{
			svgShow(){
				console.log('this.svgName' + this.svgName);
				return this.svgName;
			},
			
		},
		methods:{
			tocpz(e) {
				let routeUrl = this.$router.resolve({
					path: "/Productstation",
					query: {
						cpzname: e
					}
				});
				window.open(routeUrl.href, '_self');
			},
			go_path(e) {
				window.open(e, '_self');
			},
		}
	}
	
</script>

<style>
	
	.positionView {
		padding-bottom: 2.5rem;
		position: relative;
	}
	
	.positionView .svg {
		left: 10%;
		top:  0.75rem;
		z-index: 99;
		position:absolute;
	}
	
	.img {
		width: 85%;
		margin: 0 auto;
		background-color: #ECECEC;
		/* border: 0.0625rem red solid; */
	}
	
	.img img {
		width: 45%;
		/* height: 4%; */
		margin: 0 auto;
		padding-top: 2rem;
		padding-bottom: 2rem;
	}
	
	.product-title {
		width: 85%;
		margin: 0 auto;
		font-size: 1.15rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		text-align: left;
		padding-top: 0.7rem;
	}
	
	.product-write {
		width: 85%;
		margin: 0 auto;
		text-align: left;
		font-size: 0.8rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		padding-top: 0.5rem;
	}
	
</style>
